
import { Typography, CircularProgress, Button, useTheme, Tooltip } from '@mui/material'
import React from 'react'

interface CreateOptimizationProps {
  onClick: () => void
  isCreating: boolean
  disabled: boolean
}

const CreateOptimizationButton: React.FC<CreateOptimizationProps> = ({ onClick, isCreating, disabled }) => {
  const theme = useTheme()
  return (
    <Tooltip placement="right" title={<Typography>Log Optimizations</Typography>}>
      <Button
        sx={{
          height: '100%',
          width: '100%',
          // backgroundColor: 'rgb(29, 106, 82)',
          border: `0.5px solid`,
          bgcolor: 'background.defaultdim',
          borderColor: 'rgb(29, 106, 82)',
          justifyContent: 'left',
        }}
        // startIcon={<GpsFixedIcon size={30} />}
        disabled={isCreating || disabled}
        onClick={onClick}
        name="isApproved"
        variant="contained"
      >
        {isCreating ? (
          <Typography>
            Creating...{' '}
            <CircularProgress
              size={15}
              sx={{
                color: theme.palette.text.secondary,
              }}
            />
          </Typography>
        ) : (
          <Typography>Optimizations</Typography>
        )}
      </Button>
    </Tooltip>
  )
}

export default CreateOptimizationButton
